// ----------------------------------------------------------------------

export default function Paper() {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backdropFilter: 'blur(40px) saturate(200%)',
          WebkitBackdropFilter: 'blur(40px) saturate(200%)',
          backgroundColor: 'rgba(255,255,255,0.90)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.16), 0 0 0 0.5px rgba(60,60,67,0.10)',
          borderRadius: 20,
          border: '1px solid rgba(255,255,255,0.75)',
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.30)',
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(20px) saturate(160%)',
          WebkitBackdropFilter: 'blur(20px) saturate(160%)',
          backgroundColor: 'rgba(255,255,255,0.82)',
          boxShadow: '0 2px 20px rgba(0,0,0,0.06), 0 0 0 0.5px rgba(60,60,67,0.08)',
          border: '1px solid rgba(255,255,255,0.65)',
          borderRadius: 16,
        },
      },
    },
  };
}
